// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".lawyer_retired-module__icon--1ewgc{vertical-align:middle;font-size:25px;padding-right:5px}\n", ""]);
// Exports
exports.locals = {
	"icon": "lawyer_retired-module__icon--1ewgc"
};
module.exports = exports;
